export const API_PATH_ApiAppPresetSearchGet = '/services/app/presets/apiAppPresetSearchGet';
